var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"albums-content"},[_c('ul',{staticClass:"album-list"},_vm._l((_vm.sortedAlbums),function(album){return _c('li',{key:album.id},[_c('i',{staticClass:"fas fa-book"}),_vm._v("  "),_c('router-link',{attrs:{"to":_vm.albumPages(album)}},[_vm._v(_vm._s(album.name))])],1)}),0),_c('AlbumCreateContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }